import React from 'react';

const Footer = () => {
    return (
        <div className='p-4 bg-black text-white mt-4 text-center'>
            <h1 >Copy Rights All Access Are Reserved By SS</h1>
        </div>
    );
};

export default Footer;